export enum Action {
  Retry = "Retry",
  RetryFromScratch = "RetryFromScratch",
  Cancel = "Cancel",
}
